import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getRankingUser (params) {
    return request.get(API.ADMIN_VENDOR + params.id + '/ranking_users', params)
  },
  getRankingFile (params) {
    return request.get(API.ADMIN_VENDOR + params.id + '/ranking_files', params)
  },
  getSummary (params) {
    return request.get(API.ADMIN_VENDOR + params.id + '/summary', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/admin/dashboardEmployee.js